import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "notificationFilter" })
export class NotificationFilter implements PipeTransform {
  transform(
    array: any[],
    projectFilter: string,
    nationalityFilter: string,
    employerFilter: string,
    programFilter: string,
    countryFilter: string
  ): any[] {
    if (array) {
      return array.filter((notification) => {
        let result = true;
        if (projectFilter && projectFilter !== "undefined") {
          if (notification.projects) {
            result =
              notification.projects.filter((id) => {
                return id === projectFilter;
              }).length > 0;
          } else {
            result = false;
          }
        }
        if (programFilter && programFilter !== "undefined") {
          if (notification.programs) {
            result =
              notification.programs.filter((id) => {
                return id === programFilter;
              }).length > 0;
          } else {
            result = false;
          }
        }
        if (result) {
          if (nationalityFilter && nationalityFilter !== "undefined") {
            if (notification.nationality) {
              result =
                notification.nationality.filter((id) => {
                  return id === nationalityFilter;
                }).length > 0;
            } else {
              result = false;
            }
          }
          if (result) {
            if (employerFilter && employerFilter !== "undefined") {
              if (notification.employer) {
                result =
                  notification.employer.filter((id) => {
                    return id === employerFilter;
                  }).length > 0;
              } else {
                result = false;
              }
            }
            if (result) {
              if (countryFilter && countryFilter !== "undefined") {
                if (notification.country) {
                  result =
                    notification.country.filter((id) => {
                      return id === countryFilter;
                    }).length > 0;
                } else {
                  result = false;
                }
              }
            }
          }
        }
        return result;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/notifications.filter.ts